import store from '../'

let resource = store.defineResource({
  name: "questions",
  relations: {
    belongsTo: {
      questionGroups: {
        localField: "questionGroup",
        localKey: "groupId"
      }
    }
  }
})

export default resource



// WEBPACK FOOTER //
// ./src/store/models/questions.js